import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../Common/Footer';
import { connect } from 'react-redux';
import { sellerRequest } from '../../Action/sellerRequest';
import { withRouter } from 'react-router-dom';
import ProductsUpload from '../../Models/ProductsUpload';
import Products from '../../Models/Products';
import SimpleReactValidator from 'simple-react-validator';
import { Header } from '../Common';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
class SellerPostRequestBuyer extends React.Component {
    constructor(props) {
        super(props);
        if (localStorage.getItem('info') === null || localStorage.getItem('info') === '') {
            this.props.history.push('/login/seller');
        };
        this.state = {
            _id: false,
            modal: false,
            title: '',
            description: '',
            category: 258,
            budget: '',
            subCategory: 259,
            categoryName: '',
            budgetName: '',
            subCategoryName: '',
            date: '',
            categories: [],
            subCategories: [],
            budgets: [],
            submit_stat: false
        };
        SimpleReactValidator.addLocale('klingon', {
            integer: `${this.props.t('6')}`,
            max: `:attribute :max ${this.props.t('4')} .`,
            required: ` :attribute ${this.props.t('18')}`,
            min: `:attribute :min ${this.props.t('5')}`,
        });
        this.validator = new SimpleReactValidator({
            locale: 'klingon',
        })
        this.getCategories();
        this.getBudgetList();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    getCategories() {
        ProductsUpload.getCategoryDropdown().then(res => {
            this.setState({ categories: res.data.categories })
        })
    }

    getBudgetList() {
        Products.getBudget().then(res => {
            this.setState({ budgets: res.data.message })
        })
    }

    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleChange(e) {
        this.setState({ category: e.target.value })
        ProductsUpload.getSubCategory(e.target.value).then(res => {
            this.setState({
                subCategories: res.data.category_sub
            })
        })
    }

    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    toggleAll() {
        this.setState({
            modal: false
        });
    }

    updateChange(e) {
        this.setState({
            budget: e.target.value
        })
    }

    handleSubmit(e) {
        document.getElementById("req_post").disabled = true;
        e.preventDefault();
        if(this.state.submit_stat === false){
            var logged_user = JSON.parse(window.localStorage.getItem('info'));
            let data = {
                buyer_id: logged_user.id,
                title: this.state.title,
                application_date: this.state.date,
                content: this.state.description,
                // category: this.refs.category.value,
                // sub_category: this.refs.subCategory.value,
                category: 258,
                sub_category: 259,
                budget: this.refs.budget.value,
            }
            this.props.sellerRequest(data, this.props.history);
            this.setState({
                submit_stat: true
            });
        } else {

        }
    }

    handleClick() {
        if (this.validator.allValid()) {
            let data = {
                category: this.refs.category.value,
                subcategory: this.refs.subCategory.value,
                budget: this.refs.budget.value,
            }
            Products.getNames(data).then(res => {
                this.setState({
                    budgetName: res.data.budget,
                    categoryName: res.data.cat,
                    subCategoryName: res.data.sub_cat
                })
            })
            this.toggle()
        } else {
            this.validator.showMessages();
        }
    }

    postConfirmation() {
        return (
            <div className="">
                <Button color="" className="agree_button" onClick={this.handleClick.bind(this)}
                    style={{
                        fontSize: "16px",
                        lineHeight: "45px",
                        width: "270px",
                        padding: "2%",
                        height: "auto",
                        color: "#fff",
                        backgroundColor: "#7ea9e6",
                        borderColor: "#6290d1",
                        boxShadow: "inset 0 1px 0 hsla(0, 0%, 100%, .3)",
                        borderRadius: "9px"
                    }}>{this.props.t('2')}</Button>
                <Modal isOpen={this.state.modal} toggle={this.toggle.bind(this)} className="modal-lg" >
                    <ModalHeader toggle={this.toggle.bind(this)}>{this.props.t('7')}</ModalHeader>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    </button>
                    <ModalBody>
                        <form>
                            <fieldset style={{ border: "1px solid #008dc7" }}>
                                <div>&nbsp;</div>
                                <div className="container">
                                    <div className="row" style={{display: "flex"}}>
                                        <div className="col-md-3 common_text_bold"> {this.props.t('19')} </div>
                                        <div className="col-md-1">:</div>
                                        <div className="col-md-8" >
                                            {this.state.categoryName}
                                        </div>
                                    </div>
                                    <div className="row" style={{display: "flex"}}>
                                        <div className="col-md-3 common_text_bold"> {this.props.t('17')} </div>
                                        <div className="col-md-1">:</div>
                                        <div className="col-md-8" >
                                            {this.state.subCategoryName}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 common_text_bold"> {this.props.t('23')} </div>
                                        <div className="col-md-1">:</div>
                                        <div className="col-md-8" >
                                            {this.state.title}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 common_text_bold"> {this.props.t('12')} </div>
                                        <div className="col-md-1">:</div>
                                        <div className="col-md-8 card" style={{border:'0px'}} >
                                            <div className="">
                                                {this.state.description.split('\n').map(function (item, key) {
                                                    return (
                                                        <span key={key}>
                                                            {item}
                                                            <br />
                                                        </span>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 common_text_bold"> {this.props.t('33')} </div>
                                        <div className="col-md-1">:</div>
                                        <div className="col-md-8" >
                                            {this.state.budgetName}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 common_text_bold"> {this.props.t('24')} </div>
                                        <div className="col-md-1">:</div>
                                        <div className="col-md-8" >
                                            {this.state.date}
                                        </div>
                                    </div>

                                </div>
                                <div>&nbsp;</div>

                            </fieldset>
                            <div>&nbsp;</div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" data-dismiss="modal" onClick={this.toggle.bind(this)} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('20')}</Button>
                        <Button id="req_post"
                            onClick={this.handleSubmit.bind(this)}
                            style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>
                                {this.props.t('25')}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }

    render() {
        return (
            <div className="wrapper">
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="col-md-12 tr_blank_medium mt-5 "></div>
                <div className="container-fluid main">
                    <div className="container">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-2"></div>

                                <div className="col-md-8">
                                    <div className="">
                                        <div className="ml-5 mr-5" style={{ textAlign: "left", fontSize: "24px", borderBottom: "1px solid #ccd0c9" }}>
                                            {this.props.t('8')}
                                        </div>
                                        <div className="mini_padding">
                                            <div className="mini_padding inner-div">
                                                <div className="container">
                                                    <form >
                                                        <div className="form-group">
                                                            <label htmlFor="email" style={{display: "flex"}}><span className="request_fonts mr-4"><b>{this.props.t('19')}</b></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={{ color: 'red', fontSize: '12px' }}>*{this.props.t('34')}</span></label>
                                                            <div className="row" style={{display: "flex"}}>
                                                                <div className="col-md-7">
                                                                    <select className="catagory_select" ref="category" onChange={this.handleChange.bind(this)} value={this.state.category}>
                                                                        <option value="">{this.props.t('9')} </option>
                                                                        {this.state.categories.map(cat =>
                                                                            <option value={cat.id} key={cat.id} >
                                                                                {cat.cat_name}
                                                                            </option>
                                                                        )}
                                                                    </select>
                                                                    <span style={{ color: "red", fontSize: "12px" }}>
                                                                        {this.validator.message(this.props.t('19'), this.state.category, 'required')}
                                                                    </span>
                                                                </div>
                                                                <div className="col-md-1">
                                                                    <i className="fa fa-angle-right"></i>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <select className="catagory_select" ref="subCategory">
                                                                        <option>{this.props.t('9')} </option>
                                                                        {this.state.subCategories.map(rp =>
                                                                            <option value={rp.id} key={rp.id}>
                                                                                {rp.cat_name}
                                                                            </option>
                                                                        )}
                                                                    </select>
                                                                    <span style={{ color: "red", fontSize: "12px" }}>
                                                                        {this.validator.message(this.props.t('13'), this.state.subCategory, 'required')}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div>&nbsp;</div>
                                                        <div className="form-group">
                                                            <label htmlFor="pwd"><span className="request_fonts mr-5"><b>{this.props.t('23')}</b></span>&nbsp;&nbsp;&nbsp;<span style={{ color: 'red', fontSize: '12px' }}>*{this.props.t('34')}</span></label>
                                                            <input type="text" className="catagory_select" id="title" placeholder={this.props.t('1')} value={this.state.title} onChange={this.updateValue.bind(this, 'title')} onBlur={() => this.validator.showMessageFor(this.props.t('23'))} />
                                                            <span style={{ color: "red", fontSize: "12px" }}>
                                                                {this.validator.message(this.props.t('23'), this.state.title, 'required')}
                                                            </span>
                                                        </div>
                                                        <div>&nbsp;</div>
                                                        <div className="form-group">
                                                            <label htmlFor="pwd"><span className="request_fonts mr-4"><b>{this.props.t('12')}</b></span><span style={{ color: 'red', fontSize: '12px' }}>*{this.props.t('34')}</span></label>
                                                            <textarea className="form-control " rows="7" id="descrition"
                                                                placeholder={this.props.t('0')+".."}
                                                                value={this.state.description} onChange={this.updateValue.bind(this, 'description')}
                                                                onBlur={() => this.validator.showMessageFor(this.props.t('12'))}>
                                                            </textarea>
                                                            <span style={{ color: "red", fontSize: "12px" }}>
                                                                {this.validator.message(this.props.t('12'), this.state.description, 'required')}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <div className="row mb-3">
                                                                <div className="col-md-4">
                                                                    <span><b>{this.props.t('24')}</b></span><span style={{ color: "red", fontSize: "11px", marginLeft: '62px' }}>*{this.props.t('34')}</span>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input type="date" className="catagory_select" id="date" placeholder="Date" value={this.state.date} onChange={this.updateValue.bind(this, 'date')} />
                                                                    <span style={{ color: "red", fontSize: "12px" }}>
                                                                        {this.validator.message(this.props.t('24'), this.state.date, 'required')}
                                                                    </span>
                                                                </div>
                                                                <div className="col-md-2"></div>
                                                            </div>
                                                            <div className="row mb-3">
                                                                <div className="col-md-4">
                                                                    <span><b>{this.props.t('31')}</b></span><span style={{ color: "red", fontSize: "11px", marginLeft: '62px' }}>*{this.props.t('34')}</span>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <select
                                                                        className="catagory_select"
                                                                        onChange={this.updateChange.bind(this)}
                                                                        value={this.state.budget}
                                                                        style={{ height: "40px" }}
                                                                        ref="budget"
                                                                    >
                                                                        <option value=''>{this.props.t('9')}</option>
                                                                        {this.state.budgets.map(rp =>
                                                                            <option value={rp.id} key={rp.budget_range}>
                                                                                {rp.budget_range}
                                                                            </option>
                                                                        )}
                                                                    </select>
                                                                    <span style={{ color: "red", fontSize: "12px" }}>
                                                                        {this.validator.message(this.props.t('31'), this.state.budget, 'required')}
                                                                    </span>
                                                                </div>
                                                                <div className="col-md-2"></div>
                                                            </div>
                                                            <div className="button_div">
                                                                {this.postConfirmation()}
                                                                {/* <button type="submit" className="agree_button">{this.props.t('2')}</button> */}
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
const mapStateToProps = (state) => ({
    sellerRequest: state.sellerRequest,
    errors: state.errors,
});
SellerPostRequestBuyer = connect(mapStateToProps, { sellerRequest })(withRouter(SellerPostRequestBuyer));

export { SellerPostRequestBuyer }


 SellerPostRequestBuyer = withTranslation('src_Components_Request_SellerPostRequestBuyer')(SellerPostRequestBuyer);
